import {styleAndCapture, clsx} from 'external/material'
import {formatDate} from 'external/date-fns'

import { inViewer } from 'settings'
import {isEmpty} from 'utils/text'
import {centerVertically} from 'utils/style'

import useMenu from 'hooks/menu'
import useTranslations from 'hooks/translations'
import useCatalog from 'hooks/catalog'

import Teacher from 'components/Teacher'
import ActivitityItemColumn from './DashboardActivityItemColumn'
import DashboardActivityItemType from './DashboardActivityItemType'
import DashboardActivityMessage from './DashboardActivityMessage'
import DashboardActivityItemLink from './DashboardActivityItemLink'
import DashboardActivityItemDownload from './DashboardActivityItemDownload'

const StyledDashboardActivityItem = styleAndCapture('div', 'sidebarOpened')(dashboardActivityItemStyles)


export default function DashboardActivityItem(props) {

    const {sidebarOpened} = useMenu()

    const translations = useTranslations()
    const {translate} = translations
    const {isDownloaded} = useCatalog()
    const {activity, group = {}} = props
    const {name, content = {}, hasEpl} = activity
    const downloaded = isDownloaded({id: activity.title, hash: activity.hash})

    const lesson = activity.hasEpl ? activity.title : undefined

   const hasTitle = activity.type != 'comment' 
   const messageText =  activity.type == 'assignment'
    ? content.comments
    : activity.type == 'homework'
        ? content.instructions
        : content.message

    const title = ['assignment', 'homework'].indexOf(activity.type) >= 0
        ? activity.title
        : activity.hasEpl
            ? name && name.replace(`${lesson}: `, '')
            : messageText

   const message = !isEmpty(messageText) && {
        hasTitle,
        date: translations.formatDate(activity.modified),
        lesson: activity.hasEpl ? lesson : translate(`${activity.type}-activity-label`), title, text: messageText
    }

    const columnClass = (name, ...extra) => clsx(`${name}-column`, 'column', ...extra)

    return(<StyledDashboardActivityItem sidebarOpened={sidebarOpened}>
            <div className={columnClass('teacher')}>
                <Teacher {...group} />
            </div>
            <ActivitityItemColumn title={translate('group')} content={group.name} className={columnClass('group')} />
            <ActivitityItemColumn title={translate('schedule-event-type')} content={lesson || title} className={columnClass('content')} />
            <ActivitityItemColumn title={translate('assigned-date')} content={formatDate(activity.modified, 'dd/MM/yyyy', translations.language)} className={columnClass('assigned-date', 'date-column')} />
            <ActivitityItemColumn title={translate('assigned-to-date')} content={formatDate(activity.start, 'dd/MM/yyyy', translations.language)} className={columnClass('assigned-to-date', 'date-column')} />
            {!sidebarOpened && (<DashboardActivityItemType {...activity} className={columnClass('type')} />)}
            <DashboardActivityMessage className={columnClass('message')} message={message} />
            <DashboardActivityItemLink {...activity} lesson={lesson} className={columnClass('link', {hidden: activity.type == 'comment'})}/>
            {inViewer && <DashboardActivityItemDownload dummy={!hasEpl} {...activity} lesson={lesson} downloaded={downloaded} className={columnClass('link')}/>}
        </StyledDashboardActivityItem>
   )
}

function dashboardActivityItemStyles(props){

    const {sidebarOpened} = props

    const teacherName = sidebarOpened ? {display: 'none'} : {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        marginLeft: 15,
        color: '#313c5b',
        ...centerVertically,
        width: 100,
        fontWeight: 500,
        fontSize: '0.85rem'
    }

    return {
       display: 'flex',
       flexWrap: 'wrap',
       backgroundColor: '#fff',
       padding: '20px 15px',
       borderRadius: 10,
       marginTop: 10,
       flexShrink: 0,
        "&:first-of-type": {
            marginTop: 0
        },
        color: '#798092',
        border: 'solid 1px #e5e7ee',
        "&:hover": {
            boxShadow: '-4px 0px 15px #e5e7ee',
        },
        '& .group-column': {
            "& .content": {
                width: 90,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }
        },
        '& .content-column': {
            "& .content": {
                width: 105,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }
        },
        '& .column': {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 8,
            '&:first-of-type': {
                marginLeft: 0
            },
            '&.type-column': {
                marginLeft: 25,
                marginRight: 25,
                maxWidth: 100,
                minWidth: 100
            },
            '&.link-column': {
                maxWidth: 40,
                minWidth: 40
            },
            '&.message-column': {
                maxWidth: 40,
            },
            '&.date-column': {
                minWidth: 80
            }
        },
        '& .teacher': {
            display: 'flex',
            '& .MuiAvatar-root': {
                    height: 40,
                    width: 40,
                    fontSize: '11pt'
            },
            '& .teacherName': teacherName
        },
    }
}

